const profile = {
  title: "Mein Profil",
  premiumBtn: "Premium gehen",
  orderInfoTitle: "Kontoerlaubnis-Informationen.",
  tableProduct: "Produkt",
  tableStatus: "Status",
  tablePermissionDate: "Datum der Berechtigung",
  tableValidPeriod: "Gültiger Zeitraum",
  validStauts: "Gültig",
  expiredStauts: "Abgelaufen",
  noData: "Keine Daten",
};

export default profile;
